import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { DefaultInstitutionStoreModel } from "@bitwarden/web-vault/app/models/store/institution.store.model";
import { getLocationCurrencyFromCountryCode } from "@bitwarden/web-vault/app/models/types/location-currency.types";
import { GLOSS_VAULT } from "@bitwarden/web-vault/app/models/constants/global.constants";
import { getGlossVaultAccount } from "./default-institution-account";

export const GLOSS_VAULT_INSTITUTION_ID_PREFIX = "gloss-vault-institution-id-";
export const GLOSS_VAULT_ACCOUNT_ID_SUFFIX = "-gloss-credits-account-id";

/**
 * Returns the Gloss Vault institution ID for the given country code.
 */
export const getGlossVaultInstitutionId = (countryCode: string): string =>
  `${GLOSS_VAULT_INSTITUTION_ID_PREFIX}${countryCode}`;

/**
 * Returns the Gloss Vault institution account ID for the given institution ID.
 */
export const getGlossVaultInstitutionAccountId = (institutionId: string): string =>
  `${institutionId}${GLOSS_VAULT_ACCOUNT_ID_SUFFIX}`;

/**
 * Creates and returns the Gloss Vault institution for the given country code.
 * Used by external institutions list and when saving the institution to the user's vault.
 */
export const getGlossVaultInstitution = (countryCode: string): InstitutionView => {
  const locationCurrency = getLocationCurrencyFromCountryCode(countryCode);
  const institutionId = getGlossVaultInstitutionId(countryCode);

  const glossVaultInst = new InstitutionView({
    ...DefaultInstitutionStoreModel,
    id: institutionId,
  });
  glossVaultInst.availableAccounts[0] = getGlossVaultAccount(institutionId, locationCurrency);
  glossVaultInst.name = GLOSS_VAULT;
  glossVaultInst.swift.bankCode = "GLS";
  glossVaultInst.swift.countryCode = countryCode;
  glossVaultInst.swift.branchCode = "001";
  glossVaultInst.swift.locationCode = countryCode;

  return glossVaultInst;
};
